/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PurchaseOptionsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findAllPurchasableProducts
 */
export const FIND_ALL_PURCHASABLE_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findAllPurchasableProducts';
export const FIND_ALL_PURCHASABLE_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_ALL_PURCHASABLE_PRODUCTS_QUERY_FIELD_NAME,
  args: ['userContext'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.findAllPurchasableProductsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findIndependentPurchasableProducts
 */
export const FIND_INDEPENDENT_PURCHASABLE_PRODUCTS_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findIndependentPurchasableProducts';
export const FIND_INDEPENDENT_PURCHASABLE_PRODUCTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_INDEPENDENT_PURCHASABLE_PRODUCTS_QUERY_FIELD_NAME,
  args: ['userContext', 'productApiNames'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.findIndependentPurchasableProductsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findPurchaseOptions
 */
export const FIND_PURCHASE_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findPurchaseOptions';
export const FIND_PURCHASE_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_PURCHASE_OPTIONS_QUERY_FIELD_NAME,
  args: ['products', 'userContext'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.findPurchaseOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findPurchase
 */
export const FIND_PURCHASE_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findPurchase';
export const FIND_PURCHASE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_PURCHASE_QUERY_FIELD_NAME,
  args: ['requestedTerms', 'userContext'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.findPurchaseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findPackagedQuantityPurchaseOptions
 */
export const FIND_PACKAGED_QUANTITY_PURCHASE_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findPackagedQuantityPurchaseOptions';
export const FIND_PACKAGED_QUANTITY_PURCHASE_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_PACKAGED_QUANTITY_PURCHASE_OPTIONS_QUERY_FIELD_NAME,
  args: ['userContext', 'skuUuid', 'quantityName', 'commitmentTerm', 'paymentTerm', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.findPackagedQuantityPurchaseOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService#findQuantityPackPricingTiers
 */
export const FIND_QUANTITY_PACK_PRICING_TIERS_QUERY_FIELD_NAME = 'com_hubspot_purchase_options_rpc_PurchaseOptionsService_findQuantityPackPricingTiers';
export const FIND_QUANTITY_PACK_PRICING_TIERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FIND_QUANTITY_PACK_PRICING_TIERS_QUERY_FIELD_NAME,
  args: ['userContext', 'quantityPackSkuUuid', 'currencyCode', 'commitmentTerm', 'paymentTerm'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.findQuantityPackPricingTiersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});